/**
 * @hidden
 *
 * An object which contains the information about the cities within the timezone.
 */
export var timezones = {
    rules: {},
    titles: {},
    zones: {}
};
